import { doGet, doPut } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import type {
  CustomDashboard,
  CustomDashboardsResponse,
  EmbedUrlResponse,
} from './types';

export const getCustomDashboards = (accountId: string, projectId: string) => {
  return doGet<CustomDashboardsResponse>(
    `accounts/${accountId}/projects/${projectId}/custom-analytics`,
    LOGGER_TYPE.ANALYTICS,
    { prefix: 'nebula' },
  );
};

export const updateCustomDashboards = (
  accountId: string,
  projectId: string,
  dashboards: CustomDashboard[],
  filterByProject: boolean,
) => {
  return doPut(
    `accounts/${accountId}/projects/${projectId}/custom-analytics`,
    LOGGER_TYPE.ANALYTICS,
    {
      embed_dashboards: dashboards,
      filter_by_project: filterByProject,
    },
    { prefix: 'nebula' },
  );
};

export const getEmbedUrl = (
  accountId: string,
  projectId: string,
  dashboardId: string,
) => {
  return doGet<EmbedUrlResponse>(
    `accounts/${accountId}/projects/${projectId}/custom-analytics/${dashboardId}`,
    LOGGER_TYPE.ANALYTICS,
    { prefix: 'nebula' },
  );
};
